
import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import './PolicyModal.css';

const overlayVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
    exit: { opacity: 0 }
};

const modalVariants = {
    hidden: { scale: 0.9, opacity: 0 },
    visible: {
        scale: 1,
        opacity: 1,
        transition: { type: "spring", damping: 25, stiffness: 300 }
    },
    exit: { scale: 0.9, opacity: 0 }
};

const PolicyModal = ({ isOpen, onClose, title, content }) => {
    // Prevent body scroll when modal is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="policy-modal-overlay" onClick={onClose}>
            <motion.div
                className="policy-modal-content"
                onClick={(e) => e.stopPropagation()}
                variants={modalVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
            >
                <div className="policy-modal-header">
                    <h2 className="policy-modal-title">{title}</h2>
                    <button className="policy-modal-close" onClick={onClose} aria-label="Close">
                        <X size={18} />
                    </button>
                </div>
                <div className="policy-modal-body">
                    {content}
                </div>
            </motion.div>
        </div>
    );
};

export default PolicyModal;
